import { useContext, useEffect, useState } from 'react'
import { ReportingContext } from '../../../../contexts/reporting-context'
import DataCard from '../../../atoms/DataCard/datacard'
import { SeatBooking } from '../../../../types/andTypes'

export const FullCapacityBooking = () => {
  const { reportSeatBookingsByBU, reportBusinessUnit } = useContext(ReportingContext)
  const [daysAtFullCapacity, setDaysAtFullCapacity] = useState(0)

  useEffect(() => {
    setDaysAtFullCapacity(getFullCapacityDesks())
  }, [reportBusinessUnit, reportSeatBookingsByBU])

  const getFullCapacityDesks = () => {
    return reportSeatBookingsByBU.reduce((sum, element) => findFullCapacityDesks(sum, element), 0)
  }

  const findFullCapacityDesks = (sum: number, element: SeatBooking) => {
    if (element.seats.length === reportBusinessUnit?.deskCapacity) {
      return sum + 1
    }
    return sum
  }

  return (
    <DataCard
      id="full-capacity-card"
      title="Full Capacity"
      content={{
        mainValue: daysAtFullCapacity.toString(),
        quantifier: ' Day' + (daysAtFullCapacity === 1 ? '' : 's')
      }}
    />
  )
}
